import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  getUserPermissionsMap
} from '../store';

export function useIsUserAllowedByPermission(permissions = []) {
  const rolesIndex = useSelector(getUserPermissionsMap);
  return useMemo(
    () => permissions.length === 0
        || rolesIndex.superadmin
        || permissions.some((userRole) => rolesIndex[userRole]),
    [permissions, rolesIndex]
  );
}

export default useIsUserAllowedByPermission;
